import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchLocations } from "../../../store/locationStore/locationThunk";

// Location-filter state for report pages; kept in the page so it survives the filter bar remounting.
interface Options {
  startOn?: "default" | "all"; // "all" = All Locations, "default" = the isDefault (or only) location
}

export const useReportLocationId = ({ startOn = "all" }: Options = {}): [string, (id: string) => void] => {
  const dispatch = useAppDispatch();
  const { locations } = useAppSelector((state) => state.locations);
  const [locationId, setLocationId] = useState("");
  const appliedDefault = useRef(false);

  useEffect(() => {
    if (!locations || locations.length === 0) dispatch(fetchLocations());
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (startOn === "all" || appliedDefault.current || !locations || locations.length === 0) return;
    appliedDefault.current = true;
    const starting = locations.length === 1 ? locations[0]._id : locations.find((l) => l.isDefault)?._id;
    if (starting) setLocationId(starting);
  }, [locations]);

  return [locationId, setLocationId];
};

export default useReportLocationId;
